/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
jQuery(function($){
  // slick customized
  jQuery(".slider-double").not('.slick-initialized').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: false,
    dots: true,
    arrows: false,
    centerPadding: '20px'
  });
});

//-----
// faq
//-----
$(function(){
  //.accordion_oneの中の.accordion_headerがクリックされたら
  $('.Faq .accordion_one .accordion_header').click(function(){
    //クリックされた.accordion_oneの中の.accordion_headerに隣接する.accordion_innerが開いたり閉じたりする。
    $(this).next('.accordion_inner').slideToggle();
    $(this).toggleClass("open");
    //クリックされた.accordion_oneの中の.accordion_header以外の.accordion_oneの中の.accordion_headerに隣接する.accordion_oneの中の.accordion_innerを閉じる
    $('.Faq .accordion_one .accordion_header').not($(this)).next('.accordion_one .accordion_inner').slideUp();
    $('.Faq .accordion_one .accordion_header').not($(this)).removeClass("open");
  });
});

$(document).on("click", ".hdrSearch--toggle > span,.hdrSearch--toggle > a", function () {
  const $this = $(this);
  $this.next().slideToggle();
  $(this).parents(".hdrSearch--toggle").siblings(".hdrSearch--toggle").find(".hdrSearch__wrap").slideUp();
  return false;
});